// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React from 'react'
import './confirmationpopup.scss'
// @ts-expect-error TS7016 -- MIGRATION: not approved, fix when encountered
import { PrimaryButton, SecondaryButton } from 'ui_kit_qmd'
import closeIcon from '../../images/common/close.png'

// Utility function for selecting styles based on `isCancelledStatus`
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
const getContainerStyle = (isCancelledStatus, defaultStyle, cancelledStyle) =>
  isCancelledStatus ? cancelledStyle : defaultStyle

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
const getLabelStyle = (isCancelledStatus, defaultStyle, cancelledStyle) =>
  isCancelledStatus ? cancelledStyle : defaultStyle

export const ConfirmationPopup = ({
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  primaryBtnText,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  primaryBtnAction,
  primaryImage = undefined,
  primaryImageAlt = undefined,
  primaryImgClassName = undefined,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  secondaryBtnText,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  secondaryBtnAction,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  closeAction,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  title,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  msg,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  popUpBoxStyle,
  additionalContainerClass = '',
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  renderBody,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  id,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  isCancelledStatus,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  subTitle,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  useUpdatedStyle,
}) => (
  <div className={`confirmation-popup-container ${additionalContainerClass}`} id={id}>
    <div className='confirmation-popup-box' style={popUpBoxStyle}>
      <div className='confirmation-popup-body'>
        <span className='confirmation-popup-title'>{title}</span>
        <span className={`confirmation-popup-message ${isCancelledStatus ? '-cancelled' : ''}`}>{msg}</span>
        {subTitle ?
          <span className={`confirmation-popup-message ${isCancelledStatus ? '-cancelled' : ''}`}>{subTitle}</span>
        : null}
        {renderBody}

        <div className='confirmation-popup-button-container'>
          {secondaryBtnText ?
            <SecondaryButton
              useUpdatedStyle={useUpdatedStyle}
              btnText={secondaryBtnText}
              onPress={secondaryBtnAction}
              labelStyle={getLabelStyle(
                isCancelledStatus,
                { fontWeight: '700' },
                {
                  fontWeight: '700',
                  color: '#00818D',
                  fontSize: 20,
                },
              )}
              containerStyle={getContainerStyle(
                isCancelledStatus,
                {
                  height: 60,
                  width: 245,
                  marginRight: 12,
                  boxSizing: 'border-box',
                },
                {
                  height: 60,
                  width: 245,
                  marginRight: 12,
                  borderColor: '#E6E6E6',
                  boxSizing: 'border-box',
                },
              )}
              id='secondary-button'
            />
          : null}

          <PrimaryButton
            useUpdatedStyle={useUpdatedStyle}
            btnText={primaryBtnText}
            onPress={primaryBtnAction}
            image={primaryImage}
            imageAlt={primaryImageAlt}
            additionalImgClassName={primaryImgClassName}
            containerStyle={getContainerStyle(
              isCancelledStatus && !secondaryBtnText,
              {
                height: 60,
                width: 245,
                marginLeft: 12,
                backgroundColor: '#00818D',
              },
              {
                height: 60,
                width: '100%',
                marginLeft: 12,
                backgroundColor: '#00818D',
              },
            )}
            id='primary-button'
          />
        </div>

        <input
          type='image'
          src={closeIcon}
          alt='closeIcon'
          className='confirmation-popup-close-img'
          onClick={closeAction}
        />
      </div>
    </div>
  </div>
)

ConfirmationPopup.displayName = 'ConfirmationPopup'
